import styled from 'styled-components/macro'

export const MainSection = styled.main`
`

export const CardsContent = styled.section`
  flex: 0.8;
  padding-left: 1vh;
`

export const IllustrationContainer = styled.div`
  flex: 0.6;
  @media (max-width: 768px) {
    position: absolute;
    z-index: -1;
    opacity: 0.1;
  }
`

export const PresentationText = styled.p`
  font-size: 18px;
  line-height: 30px;
  color: ${({ theme }) => theme.primary};

  @media (max-width: 980px) {
    font-size: 16px;
    line-height: 32px;
    text-align: justify;
  }
`

export const HighlightedWord = styled.p`
  font-size: 38px;
  font-weight: 500;
  margin-bottom: 10px;
  color: ${({ theme }) => theme.primary};
  margin-top: 10px;
  text-transform: capitalize;
`

export const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  padding-top: 1rem;
  padding-left: 1rem;
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    margin-top: 10%;
  }
`

export const LinksWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-bottom: 1rem;

  @media (max-width: 1100px) {
    margin: 15px 0 15px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const MaterialContainer = styled.div`
  background-color: #f8faf8;
  border: 1px solid #d4e6d0;
  border-radius: 12px;
  padding: 1.5rem 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
  width: 100%;
  justify-self: center;
  margin-bottom: 1rem;

  @media (max-width: 986px) {
    flex-direction: column;
    text-align: center;
    gap: 1.5rem;
    padding: 1.5rem;
  }
`;

export const IconCircle = styled.div`
  background-color: #dbedd9;
  border-radius: 50%;
  width: 85px;
  height: 85px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TextContent = styled.div`
  flex: 1;
  h2 {
    color: #008751;
    margin: 0 0 6px 0;
  }
  
  p {
    line-height: 1.5;
  }
`;

export const ButtonAcessar = styled.button`
  background-color: #008751;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 14px 28px;
  font-size: 1rem;
  font-weight: 600;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background-color: #006e41;
  }

  @media (max-width: 986px) {
    width: 100%;
  }
`;